import { render } from "./AppVersionModal.vue?vue&type=template&id=ccf18bce"
import script from "./AppVersionModal.vue?vue&type=script&lang=js"
export * from "./AppVersionModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__